import React, { useEffect, useState } from "react";
import ImageUpload from "../ImageUpload/ImageUpload.jsx";
import { MdOutlineInsertPhoto } from "react-icons/md";
import { useCreateCompanyMutation, useGetCompanyQuery } from "../../redux/slice/company/Company.js";
import { toast } from "react-toastify";

export default function Settings({ skip }) {
  const { data } = useGetCompanyQuery({ skip })
  const [inputValue, setInputValue] = useState({
    begin_date: "",
    end_date: "",
    study_price: "",
    hostel_price: "",
    logo: "",

    cam1_login: "",
    cam1_password: "",
    cam1_ip: "",
    cam1_start_time: "",
    cam1_finish_time: "",

    cam2_login: "",
    cam2_password: "",
    cam2_ip: "",
    cam2_start_time: "",
    cam2_finish_time: "",

    id: "",
  });

  useEffect(() => {
    if (data && data.length > 0) {
      const latestData = data[data.length - 1]; // Assuming you want to use the latest data
      setInputValue({
        begin_date: latestData.begin_date || "",
        end_date: latestData.end_date || "",
        study_price: latestData.study_price || "",
        hostel_price: latestData.hostel_price || "",
        logo: latestData.logo || "",
        camera_entrance: latestData.camera_entrance || "",
        camera_exit: latestData.camera_exit || "",
        id: latestData.id || "",
      });
    }
  }, [data]);
  const [createCompany, { isLoading }] = useCreateCompanyMutation(inputValue?.id);

  const addData = async () => {
    const formData = new FormData();
    formData.append('begin_date', inputValue.begin_date);
    formData.append('end_date', inputValue.end_date);
    formData.append('study_price', inputValue.study_price);
    formData.append('hostel_price', inputValue.hostel_price);
    formData.append('logo', inputValue.logo);


    formData.append('cam1_login', inputValue.cam1_login);
    formData.append('cam1_password', inputValue.cam1_password);
    formData.append('cam1_ip', inputValue.cam1_ip);
    formData.append('cam1_start_time', inputValue.cam1_start_time);
    formData.append('cam1_finish_time', inputValue.cam1_finish_time);

    formData.append('cam2_login', inputValue.cam2_login);
    formData.append('cam2_password', inputValue.cam2_password);
    formData.append('cam2_ip', inputValue.cam2_ip);
    formData.append('cam2_start_time', inputValue.cam2_start_time);
    formData.append('cam2_finish_time', inputValue.cam2_finish_time);



    try {
      await createCompany(formData).unwrap();
      toast.success(`Al-Xorazimiy ma'lumotlari  qo'shildi`);
    } catch (error) {
      toast.error(`Al-Xorazimiy ma'lumotlari  qo'shilmadi !!!`);
    }
  }
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = `${today.getMonth() + 1}`.padStart(2, '0'); // Oy 0dan boshlansa, 2 raqam bo'ladi
    const day = `${today.getDate()}`.padStart(2, '0'); // Kun 0dan boshlansa, 2 raqam bo'ladi
    return `${year}-${month}-${day}`;
  };

  return (
    <div
      className={`fixed bottom-0 h-[90vh] w-[70%] bg-white border z-10 ${skip === true ? "right-0" : "-right-[20rem]"
        } transition-all duration-500 p-4 flex flex-col justify-between`}
    >
      <div>
        <div className="grid gap-10 grid-cols-2">
          <div className="flex flex-col gap-5 ">
            <h1 className="text-2xl font-bold">Sozlamalar</h1>
            <div className="col-span-1 row-span-1 relative">
              <label htmlFor="O'qish To'lovi">O'qish To'lovi</label>
              <input
                id="salary"
                name="user.salary"
                type="text"
                autoComplete="salary"
                placeholder="O'qish To'lovi"
                value={inputValue?.study_price}
                required
                pattern="[0-9]*"
                onChange={(e) => {
                  const inputValueCopy = { ...inputValue };
                  const inputSalary = e.target.value;
                  inputValueCopy.study_price = inputSalary;
                  setInputValue(inputValueCopy);
                }}
                className="block w-full rounded-md border-0 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
              <span className="text-red-600" >
                {inputValue.salary !== null && isNaN(inputValue.study_price)
                  ? <p className="text-red-600 absolute text-[12px] -bottom-4">Iltimos faqad raqam ishlating !</p>
                  : ''}
              </span>
            </div>
            <div className="col-span-1 row-span-1 relative">
              <label htmlFor="Turar Joy Uchun To'lov">Turar Joy Uchun To'lov</label>
              <input
                id="salary"
                name="user.salary"
                type="text"
                autoComplete="salary"
                placeholder="Turar Joy Uchun To'lov"
                required
                value={inputValue?.hostel_price}
                pattern="[0-9]*"
                onChange={(e) => {
                  const inputValueCopy = { ...inputValue };
                  const inputSalary = e.target.value;
                  inputValueCopy.hostel_price = inputSalary;
                  setInputValue(inputValueCopy);
                }}
                className="block w-full rounded-md border-0 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
              <span className="text-red-600" >
                {inputValue.salary !== null && isNaN(inputValue.hostel_price)
                  ? <p className="text-red-600 absolute text-[12px] -bottom-4">Iltimos faqad raqam ishlating !</p>
                  : ''}
              </span>
            </div>

            <div>
              <label >O'qish boshlanish sanasi</label>
              <input
                type="date"
                onChange={(e) => setInputValue({ ...inputValue, begin_date: e.target.value })}
                value={inputValue.begin_date || getCurrentDate()} // Hozirgi san'atni olish
                className="block w-full rounded-md border-0 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
            <div>
              <label> O'qish tugash sanasi</label>
              <input
                type="date"
                onChange={(e) => setInputValue({ ...inputValue, end_date: e.target.value })}
                value={inputValue.end_date || getCurrentDate()} // Hozirgi san'atni olish
                className="block w-full rounded-md border-0 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>


            <ImageUpload
              value={inputValue?.logo}
              title={"Logo"}
              iconName={<MdOutlineInsertPhoto className="text-5xl" />}
              iconTitle={"Rasmni Yuklash"}
              fileType={"PNG, JPG, JPEG 5mb gacha"}
              LabelFor={"logo"}
              setInputValue={setInputValue}
              inputValue={inputValue}
            />
          </div>

          <div className="grid grid-cols-2  gap-10">
            <div className="flex flex-col gap-5">
              <h1 className="text-1xl font-bold">Kamera  Kirish </h1>
              <div>
                <label>Login</label>
                <input
                  type="text"
                  onChange={(e) => setInputValue({ ...inputValue, cam1_login: e.target.value })}
                  value={inputValue?.cam1_login} // Hozirgi san'atni olish
                  className="block w-full rounded-md border-0 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
              <div>
                <label>Passwords</label>
                <input
                  type="text"
                  onChange={(e) => setInputValue({ ...inputValue, cam1_password: e.target.value })}
                  value={inputValue?.cam1_password} // Hozirgi san'atni olish
                  className="block w-full rounded-md border-0 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
              <div>
                <label>Kamera ip</label>
                <input
                  type="text"
                  onChange={(e) => setInputValue({ ...inputValue, cam1_ip: e.target.value })}
                  value={inputValue?.cam1_ip} // Hozirgi san'atni olish
                  className="block w-full rounded-md border-0 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
              <div>
                <label> Ish boshlash vaqti</label>
                <input
                  type="time"
                  onChange={(e) => setInputValue({ ...inputValue, cam1_start_time: e.target.value })}
                  value={inputValue?.cam1_start_time} // Hozirgi san'atni olish
                  className="block w-full rounded-md border-0 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>

              <div>
                <label> Ish Tugatish vaqti  </label>
                <input
                  type="time"
                  onChange={(e) => setInputValue({ ...inputValue, cam1_finish_time: e.target.value })}
                  value={inputValue?.cam1_finish_time} // Hozirgi san'atni olish
                  className="block w-full rounded-md border-0 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
            <div className="flex flex-col gap-5">
              <h1 className="text-1xl font-bold">Kamera  Chiqish </h1>
              <div>
                <label>Login</label>
                <input
                  type="text"
                  onChange={(e) => setInputValue({ ...inputValue, cam2_login: e.target.value })}
                  value={inputValue?.cam2_login} // Hozirgi san'atni olish
                  className="block w-full rounded-md border-0 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
              <div>
                <label>Password</label>
                <input
                  type="text"
                  onChange={(e) => setInputValue({ ...inputValue, cam2_password: e.target.value })}
                  value={inputValue?.cam2_password} // Hozirgi san'atni olish
                  className="block w-full rounded-md border-0 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
              <div>
                <label>Kamera ip</label>
                <input
                  type="text"
                  onChange={(e) => setInputValue({ ...inputValue, cam2_ip: e.target.value })}
                  value={inputValue?.cam2_ip} // Hozirgi san'atni olish
                  className="block w-full rounded-md border-0 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
              <div>
                <label> Ish boshlash vaqti</label>
                <input
                  type="time"
                  onChange={(e) => setInputValue({ ...inputValue, cam2_start_time: e.target.value })}
                  value={inputValue?.cam2_start_time} // Hozirgi san'atni olish
                  className="block w-full rounded-md border-0 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>

              <div>
                <label> Ish yakullash vaqti</label>
                <input
                  type="time"
                  onChange={(e) => setInputValue({ ...inputValue, cam2_finish_time: e.target.value })}
                  value={inputValue?.cam2_finish_time} // Hozirgi san'atni olish
                  className="block w-full rounded-md border-0 py-1 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
          </div>
          <div>

          </div>
          <div className="flex justify-end">
            <button
              onClick={() => addData()}
              className={`text-sm bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-4 rounded inline-flex items-center justify-center ${isLoading ? 'opacity-50 cursor-not-allowed' : ''
                }`}
              disabled={isLoading}
            >
              {isLoading ? 'Yuborilmoqda...' : 'Saqlash'}
            </button>
          </div>
        </div>
      </div>



    </div>
  );
}
